module.exports = __webpack_public_path__ + "static/media/weather.a63d3367.png";